export default {
  label: {
    time: '根据时间搜索',
    orderNo: '根据订单号搜索',
    amount: '金额',
    channelCode: '通道编码',
    channelType: '通道类型',
    createAcct: '创建者账号',
    createTime: '创建时间',
    id: '主键ID',
    merchantNo: '商户号',
    merchantOrderNo: '	商户订单',
    status: '	交易状态',
    systemOrderNo: '系统订单号',
    BeginTime: '起止时间',
    serviceType: '服务类型',

    accountNumber: '收款账号',
    currency: '币种	',
    extra: '额外参数	',
    message: '订单消息	',
    notifyUrl: '订单回调地址	',
    remark: '备注	',
    sign: '签名	',
    updateAcct: '修改人账号',
    updateTime: '修改时间',
    userIP: '支付用户的IP',

  },
  rules: {
    amount: '金额不能为空',
    channelCode: '通道编码必须选择',
    channelType: '通道类型必须选择',
    createAcct: '创建者账号不能为空',
    createTime: '创建时间必须选择',
    id: '主键ID不能为空',
    merchantNo: '商户号不能为空',
    merchantOrderNo: '	商户订单不能为空',
    status: '	交易状态必须选择',
    systemOrderNo: '系统订单号不能为空',
    BeginTime: '起止时间必须选择',
    serviceType: '服务类型必须选择'
  },

};



// WEBPACK FOOTER //
// ./src/i18n/lang/zh/transaction.js